import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { StandortsQuerySorterConfig } from 'fa-kt.types';
import { StandortsService } from '../service';

@Component({
  selector: 'fa-kt-standorts-sorter',
  templateUrl: './standorts-sorter.component.html',
  styleUrls: ['./standorts-sorter.component.css'],
})
export class StandortsSorterComponent {
  StandortsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public standorts: StandortsService,
  ) {
    this.StandortsSorterConfig = StandortsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
